<template>
	<select v-model="selected" class='form-control my-control table-control' disabled>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ACTION_TYPE = 'get_action_type.php'
	const LOCATION = 'get_conclusion_location.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'actionType',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: ''
		},
		created: function () {
			fetch(DB + LOCATION + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				const at = res.filter(item => {
					return item.field == 'f_16'
				})
				//console.log(at[this.line_count], this.line_count)

				if (at.length !== 0)
					return at[this.line_count].val
				else {
					return '0'
				}
			})
			.then(id => {
				fetch(DB + ACTION_TYPE, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = [{id: '0', name: ''}, ...data];
						this.selected = id
					}
					else {
						this.options = []
						this.selected = '0'
					}
				})
				.catch(err => console.log('7',err))
			})
			.catch(err => console.log('8',err))
		}
	}
</script>


// WEBPACK FOOTER //
// actionType.vue?162a4e1c